import { render, staticRenderFns } from "./MediaUploadTab.vue?vue&type=template&id=73ae4b1a"
import script from "./MediaUploadTab.vue?vue&type=script&lang=js"
export * from "./MediaUploadTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports